export default __webpack_public_path__ + "assets/margin-onboarding-77e8912ef2577545af74f79325e47297.mp4";